import formatter from "../constants/currencyFormatter"
import { DateTime } from "luxon"

const transferFilter = (transfers, filter) => {
  return(
    transfers.filter((transfer) =>
    `${transfer.attributes.make} ${transfer.attributes.model}`.toLowerCase().includes(filter.toLowerCase()) ||
      formatter.format(transfer.attributes.amount).includes(filter) ||
      transfer.attributes['payment-type'].toLowerCase().includes(filter.toLowerCase()) ||
      transfer.attributes.vin.toLowerCase().includes(filter.toLowerCase()) ||
      new Date(transfer.attributes['actual-transfer-date'])
        .toLocaleDateString('en-US', { year: '2-digit', month: 'numeric', day: 'numeric'})
        .includes(filter.toLowerCase())
    )
  )
}

const txnFilter = (txns, filter) => {
  if (!txns || txns.length === 0) return []

  return(
    txns.filter((txn) =>
      txn.attributes.units.map((unit) => `${unit.make} ${unit.model} ${unit.vin}`).join(', ').toLowerCase().includes(filter.toLowerCase()) ||
      formatter.format(txn.attributes.amount).includes(filter) ||
      txn.attributes['type-s'].toLowerCase().includes(filter.toLowerCase()) ||
      DateTime.fromISO(txn.attributes['cdate']).toFormat('M/d/yy').includes(filter.toLowerCase())
    )
  )
}

export default transferFilter
export { txnFilter }